import { RLearningContentProvider, RLearningContentContentType, RLearningContentLocationData } from '@/store/v2';
import { slugify } from '@/utils/misc';
import { ParticipationV3 } from '@/store/v2/catalog-v2/model/participation';
import { ROUTE_PATH } from '@/constants/routePaths';

export type LearningContent = {
  id: string;
  title: string;
  description: string;
  imageURL?: string;
  provider: RLearningContentProvider;
  plannedDuration?: number;
  plannedLearningsCount?: number;
  locations?: RLearningContentLocationData[];
  metadata?: {
    language?: string;
    level?: string;
    type?: RLearningContentContentType;
    timezone?: number;
    systemGenerated?: boolean;
  };
  curations: LearningCuration[];
  progress?: LearningContentProgress;
};

type LearningContentProgress = ParticipationV3;

type LearningCuration = {
  id: string;
  spaceId: number;
  launchURLPath?: string;
  title?: string;
  description?: string;
  imageURL?: string;
  editURLPath?: string;
  systemGenerated?: boolean;
};

export function learningContentDisplayMeta(
  content?: Omit<LearningContent, 'progress'>,
  spaceId?: number,
  journey?: { id: number; title: string },
): { title?: string; imageUrl?: string; launchPath?: string; editURLPath?: string; systemGenerated?: boolean } {
  const curation = spaceId ? content?.curations?.find((curation) => curation.spaceId === spaceId) : content?.curations?.[0];

  return {
    title: curation?.title || content?.title || '',
    imageUrl: curation?.imageURL || content?.imageURL,
    launchPath:
      content?.metadata?.type === RLearningContentContentType.Section
        ? `${ROUTE_PATH.JOURNEY_BASE}/${journey?.id}/${slugify(journey?.title || 'untitled')}/section/${curation?.id
            ?.split(':')
            .pop()}?noScroll=true`
        : curation?.launchURLPath,
    editURLPath: curation?.editURLPath,
    systemGenerated: curation?.systemGenerated,
  };
}
